module.exports = __webpack_public_path__ + "static/portfolio-aifirst-4051935c075514fd89953a0c4bc49fba.jpg";